import { ProjectStatusE } from "../../../models/enums";
import { RoutesE } from "../../../routes/routesData";
import { UnfinishedDeliveryT } from "../models";

const getRoute = (item: UnfinishedDeliveryT) => {
    const deliveryId = item?.projectUrl.split("/")?.[3];

    if (item?.projectStatus === ProjectStatusE.Opened) {
      return `${RoutesE.DELIVERIES}/${deliveryId}`;
    }
    if (item?.projectStatus === ProjectStatusE.WaitingForApprovalOfPostProduction) {
      return `${RoutesE.DELIVERIES}/${deliveryId}`;
    }
    // if (!item?.DeliveryStatus) {
      return `/projects/order-payment/${deliveryId}`;
    // }

    // return `${RoutesE.DELIVERIES}/${deliveryId}`;
  };

  export default getRoute;